import { MenuOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  isOpen: boolean;
  children: ReactNode;
  onToggle: () => void;
};

export const SidebarContainer = ({ isOpen, children, onToggle }: Props) => {
  return (
    <Box
      display="grid"
      minHeight="calc(100dvh - 63px)"
      position="relative"
      gridTemplateColumns={!isOpen ? 'auto 0' : `auto 420px`}
      sx={(theme) => ({
        transition: '300ms',
        [theme.breakpoints.down('md')]: {
          gridTemplateColumns: 'auto 0',
        },
      })}
    >
      {children}
      <Box position="absolute" top={12} right={8}>
        <IconButton onClick={onToggle}>
          <MenuOutlined />
        </IconButton>
      </Box>
    </Box>
  );
};
